module.exports = __webpack_public_path__ + "item2.cdb8515d70eaaa0f355b17fbfd80f7d0.svg";